<template>
    <div 
        class="table-base"
        :class="{'preloader-content': isPreloader}"
    >
        <div
                v-if="isPreloader"
                class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table v-if="!isPreloader">
            <thead>
                <tr>
                    <th
                        v-for="(column, indexColumn) of labels"
                        :key="indexColumn"
                    >
                        <div class="table-base__th-container">
                            {{column}}
                        </div>
                    </th>
                    <th v-if="isActionButtons"></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(row, indexRow) of rows"
                    :key="indexRow"
                >
                    <td
                        v-for="(column, indexColumn) of labels"
                        :key="indexColumn"
                    >
                        <div class="settings-cell-data"
                            v-if="columnSettings[indexColumn].type === 'text'"
                        >
                            {{row[indexColumn]}}
                        </div>
                        <div class="settings-cell-data"
                             v-if="columnSettings[indexColumn].type === 'link'"
                        >
                            <a
                                    target="_blank"
                                    :href="row[indexColumn]"
                            >
                                Скачать
                            </a>
                        </div>
                        <div class="settings-cell-data"
                             v-if="columnSettings[indexColumn].type === 'emit'"
                        >
                            <a
                                    class="emit-link"
                                    @click="$emit('clickTableCell', row, indexColumn)"
                            >
                                {{row[indexColumn]}}
                            </a>
                        </div>
                        <div class="settings-cell-data"
                                v-if="columnSettings[indexColumn].type === 'input'"
                                @dblclick="openInput(indexRow, indexColumn, row)"
                        >
                            <input
                                    v-if="isOpened(indexRow, indexColumn)"
                                    v-model="edited['value']"
                                    @change="onCellInputChange()"
                                    @blur="hideInput()"
                                    :ref="indexRow + '_' + indexColumn"
                                    class="setting-cell-input"
                            >
                            <div v-if="!isOpened(indexRow, indexColumn)">{{row[indexColumn]}}</div>
                        </div>
                        <div class="settings-cell-data"
                             v-if="columnSettings[indexColumn].type === 'dropDown'"
                        >
                            <dropdown
                                v-if="true"
                                :title="dropDownTitle(indexColumn)"
                                :items="columnSettings[indexColumn].values"
                                :selectedItems="columnSettings[indexColumn].selected[row.id]"
                                :isManyItems="isManyItems(indexColumn)"
                                :width="'220px'"
                                :height="'44px'"
                                :prompt="typeof columnSettings[indexColumn].prompt !== 'undefined' ? columnSettings[indexColumn].prompt : 'Выберите значение'"
                                @onChange="onChangeDropdown($event, indexColumn, row)"
                            />
                        </div>
                    </td>
                    <td v-if="isActionButtons">
                        <button class="remove-client__btn" @click="removeRow(row)">x</button>
                    </td>
                    <td v-if="Object.keys(row).includes('additionalButtons') && row.additionalButtons.length">
                        <button
                                v-if="row.additionalButtons.includes('send')"
                                class="remove-client__btn"
                                @click="sendRow(row)"
                        >Отправить</button>
                        <button
                                v-if="row.additionalButtons.includes('remove')"
                                class="remove-client__btn"
                                @click="removeRow(row)"
                        >Удалить</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Dropdown from '../Base/Dropdown';
export default {
    name: 'TableSettings',
    components: {
        Dropdown
    },
    /**
     * Входные данные компонента
     * @property {Array} rows - строки
     * @property {object} labels - заголовки
     * @property {object} columnSettings - Настройки атрибутов
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {boolean} isActionButtons - столбец действий
     */
    props: {
        rows: {
            type: Array,
            default: () => ([])
        },
        labels: {
            type: Object,
            default: () => ({})
        },
        columnSettings: {
            type: Object,
            default: () => ({})
        },
        isPreloader: {
            type: Boolean,
            default: false
        },
        isActionButtons: {
            type: Boolean,
            default: false
        },
        isEditable: {
          type: Boolean,
          default: true
        }
    },
    /**
     * данные компонента
     * @property {array} edited - данные отредактированного инпута
     * @property {string} opened - ключ открытого инпута
     */
    data: () => ({
        edited: [],
        opened: null
    }),
    methods: {
        /**
         * Отправка отредактированных данных
         */
        onCellInputChange(){
            this.$emit('editedCellInput', this.edited);
            this.opened = null;
            this.edited = [];
        },
        /**
         * Проверка открыт ли инпут
         * @property {number} rownum - номер строки
         * @property {string} attribute - редактируемый атрибут
         */
        isOpened(rownum, attribute){
            if(
                this.opened === rownum + "_" + attribute
            ){
                return true;
            }
            return false;
        },
        /**
         * Открытие инпута и фокусировка на нем
         * @property {number} rownum - номер строки
         * @property {string} attribute - редактируемый атрибут
         * @property {Object} row - строка таблицы
         */
        openInput(rownum, attribute, row){
            if(!this.isEditable){
              return;
            }
            this.opened = rownum + "_" + attribute;
            this.edited['attribute'] = attribute;
            this.edited['id'] = row['id'];
            this.edited['value'] = row[attribute];
            this.$set(row, 'edit_mode', true);
            this.$nextTick(() => {
                this.$refs[rownum + "_" + attribute][0].focus();
            });
        },
        /**
         * скрыть все инпуты
         */
        hideInput(){
            this.opened = null;
        },
        /**
         * изменить значение дропдауна
         * @property {Array} selected - выбранные значения
         * @property {string} attribute - редактируемый атрибут
         * @property {Object} row - строка таблицы
         */
        onChangeDropdown(selected, attribute, row) {
            let selectedObj = this.columnSettings[attribute].selected;
            selectedObj[row[attribute]] = selected;
            this.$set(this.columnSettings[attribute], 'selected', selectedObj);
            let newDropdownData = {
                attribute: attribute,
                selected: selected,
                row: row
            }
            this.$emit('changeDropdown', newDropdownData);
        },
        /**
         * удаление строки
         * @property {Object} row - строка таблицы
         */
        removeRow(row){
            this.$emit('removeRow', row);
        },
        sendRow(row){
            this.$emit('sendRow', row);
        },
        isManyItems(index){
            return !Object.keys(this.columnSettings[index]).includes('isManyItems') || this.columnSettings[index].isManyItems;
        },
        dropDownTitle(index){
          return !Object.keys(this.columnSettings[index]).includes('title') ? 'Менеджеры' : this.columnSettings[index].title;
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-base {
        position: relative;
        overflow-x: auto;
        width: 100%;
    }
    .table-base table {
        border-collapse: collapse;
        width: 100%;
    }
    .table-base th {
        font-family: Arial;
        font-weight: bold;
        text-align: left;
        border: 1px solid #ddd;
        padding: 5px 5px 5px 5px;
    }
    .table-base__th-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .table-base td {
        border: 1px solid #ddd;
        padding: 1px 1px 1px 1px;
    }
    .settings-cell-data {
        padding: 4px 4px 4px 4px;
    }
    .emit-link{
        cursor: pointer;
        text-decoration: underline;
        color: #2686e6;
    }
    .table-base__td-number {
        text-align: right;
    }
    .table-base__sort {
        visibility: hidden;
    }
    .table-base th:hover .table-base__sort{
        visibility: visible;
    }
    .table-base__sort_active {
        visibility: visible;
    }
    .table-base__cell-val{
        display: block;
    }
    .table-base__cell-diff{
        display: block;
        font-size: 12px;
    }
    .setting-cell-input{
        background: #fff;
        border: 1px solid #fff;
        outline: 0;
        /*padding: 0 40px;*/
        border-radius: 60px;
    }
    .preloader-content{
        padding: 30px;
    }
    .remove-client__btn{
        border-radius: 10px;
        border: none;
        background: none;
        color: #c8c8c8;
        cursor: pointer;
        outline: none;
    }
</style>